module.exports = __webpack_public_path__ + "img/Dante.74e9f17b.jpg";